import { useBackendApi } from './backendApi';
import { useEventsPublisher, useEventsSubscriber } from 'event-bus';
import { PROJECT_UPDATED } from './Types';

export interface CreateNewExternalProjectRequest {
  connectionProfileId: number;
}

export const PROJECT_SYNCING_UPDATED = 'PROJECT_SYNCING_UPDATED';

export function useProjectSyncingService() {
  const nekstApi = useBackendApi();
  const eventsPublisher = useEventsPublisher();

  useEventsSubscriber('projectSyncingService', {
    [PROJECT_SYNCING_UPDATED]: () => {
      // Handle any cache clearing or updates if needed
    }
  }, []);

  const createNewExternalProject = async (projectId: number, request: CreateNewExternalProjectRequest): Promise<void> => {
    await nekstApi.post(`/projects/${projectId}/newexternalproject`, request);
    eventsPublisher.publish(PROJECT_SYNCING_UPDATED, {});
  };

  return {
    createNewExternalProject
  };
}
